import React, { useEffect, useRef, useState } from "react";
import { Col, Form, FormLabel, Row, Spinner } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import infoIcon from "../../assets/images/infobtnblue.svg";
import PlusPlaceholder from "../../assets/images/PlusImage.png";
import CKeditorComponent from "../../component/common-component/CKeditorComponent";
import { commonservices } from "../../services/CommonServices";
import { apiCall } from "../../services/AxiosService";
import { API_URL } from "../../services/APIRoute";
import { apiResponse } from "../../services/APIResponse";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { userInfo } from "../../services/ReduxTookit/UserInfoSlice";
import "./myprofile.css";
// import profileicon from "../../assets/images/profileicon.svg";
import profileicon from "../../assets/images/dummy-profile-pic.jpg";
import {
  GetByPrimarykey,
  UserProfileUpdate,
} from "../../services/ReduxTookit/Slice/UserRedux";
import SubmitLoading from "../common-component/Loaders/SubmitLoading";
import MainpageLoader from "../common-component/Loaders/MainpageLoader";

const ProfileModule = () => {
  let ProfileInfo = useSelector((state) => state?.userinfo?.UserInfo);
  let dispatch = useDispatch();
  const [Loading, setLoading] = useState(false);
  const [ProfileDetailLoading, setProfileDetailLoading] = useState(false);
  const ProfileImgref = useRef();
  const [file, setFile] = useState();
  const [input, setInput] = useState({
    displayname: "",
    istwostepenable: "",
    twostepemailid: "",
    profilepicfile: "",
    privacypolicy: "",
    termsandcondition: "",
    supportemail: "",
    errors: {
      displayname: "",
      istwostepenable: "",
      twostepemailid: "",
      profilepicfile: "",

      supportemail: "",
      // privacypolicy: "",
      // termsandcondition: "",
      ValidationRules: [
        {
          FieldName: "displayname",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        // {
        //   FieldName: "privacypolicy",
        //   ValidationType: "required",
        //   ValidationMessage: "This Field is a required field",
        // },
        // {
        //   FieldName: "termsandcondition",
        //   ValidationType: "required",
        //   ValidationMessage: "This Field is a required field",
        // },
        {
          FieldName: "supportemail",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "supportemail",
          ValidationType: "email",
          ValidationMessage: "Enter valid email format required",
        },
      ],
    },
  });

  const ProfileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file.type !== "image/png" && file.type !== "image/jpeg") {
      return toast.error("Only PNG and JPEG images are allowed.");
    }
    setInput({
      ...input,
      profilepicfile: file,
    });
    setFile(URL.createObjectURL(file));
  };

  async function getProfileDetail() {
    setProfileDetailLoading(true);
    // let resData = await apiCall(
    //   {
    //     method: "POST",
    //     url: API_URL.BASEURL + API_URL.PROFILE_DETAIL,
    //     body: {},
    //   },
    //   false
    // );
    // let response = apiResponse(false, resData, setProfileDetailLoading);
    dispatch(GetByPrimarykey({}))?.then((response) => {
      setProfileDetailLoading(false);

      if (response?.payload?.isValidate) {
        if (response?.payload?.data?.data) {
          setFile(response?.payload?.data?.data?.profilepicurl);
          setInput({
            ...input,
            displayname: response?.payload?.data?.data?.displayname,
            istwostepenable: response?.payload?.data?.data?.istwostepenable,
            twostepemailid: response?.payload?.data?.data?.twostepemailid,
            profilepicfile: response?.payload?.data?.data?.profilepicurl,
            privacypolicy: "",
            termsandcondition: "",
            supportemail: response?.payload?.data?.data?.supportemail,
          });
        }
      }
      if (!response?.payload?.isValidate) {
      }
    });
  }
  useEffect(() => {
    getProfileDetail();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    let obj = commonservices.fnCheckValidationOfObject(input);
    setInput({
      ...obj.obj,
    });
    if (obj.isValid) {
      setLoading(true);

      let body = {
        displayname: input?.displayname
          ? input?.displayname?.trim()
          : input?.displayname,
        istwostepenable: input?.istwostepenable,
        twostepemailid: input?.twostepemailid
          ? input?.twostepemailid?.trim()
          : input?.twostepemailid,
        profilepicfile: input?.profilepicfile,
        privacypolicy: input?.privacypolicy,
        termsandcondition: input?.termsandcondition,
        supportemail: input?.supportemail,
      };
      // let resData = await apiCall(
      //   {
      //     method: "POST",
      //     url: API_URL.BASEURL + API_URL.PROFILE_UPDATE,
      //     body: body,
      //   },
      //   true
      // );
      // let response = apiResponse(true, resData, setLoading);

      dispatch(UserProfileUpdate(body))?.then((response) => {
        setLoading(false);
        if (response?.payload?.isValidate) {
          if (response?.payload?.data?.data) {
            dispatch(
              userInfo({
                ...ProfileInfo,
                displayname: response?.payload?.data?.data?.displayname,
                profilepic: response?.payload?.data?.data?.profilepicurl,
              })
            );
          }
        }

        if (!response?.payload?.isValidate) {
        }
      });
    }
  };

  const handleCKEditor = (content, tag) => {
    setInput({
      ...input,
      [tag]: content,
    });
  };

  return (
    <>
    {Loading && <MainpageLoader/>}
      <div class="profile-section">
        <div className="d-flex mb-3 ms-2">
          <div>
            {file ? (
              <img
                src={file}
                style={{ width: "50px", height: "50px", borderRadius: "50%" }}
                alt="User Logo"
              />
            ) : (
              <img
                src={profileicon}
                style={{ width: "50px", height: "50px", borderRadius: "50%" }}
                alt="User Logo"
              />
            )}
          </div>
          <h2 className="mt-2 ms-2"> My Profile</h2>
        </div>
        <Form
          onSubmit={(e) => {
            handleSubmit(e);
          }}
        >
          <div className="container-section">
            <>
              <Row>
                <Col xl={5} lg={5} md={5}>
                  <Form.Group className="form-group">
                    <Form.Label className="login-label">
                      Display Name{" "}
                      <span className="ms-1 red-color-text">*</span>
                    </Form.Label>
                    <div className="position-relative">
                      <Form.Control
                        type="text"
                        maxLength={67}
                        placeholder="Display name"
                        className="common-input"
                        value={input.displayname}
                        onChange={(e) =>
                          setInput({
                            ...input,
                            displayname: e.target.value,
                          })
                        }
                        isInvalid={input?.errors?.displayname}
                      />
                      {input.errors.displayname && (
                        <Form.Control.Feedback type="invalid">
                          <span className="error-message-icon">
                            <img
                              src={infoIcon}
                              alt="infoIcon"
                              title={input.errors.displayname}
                            />
                          </span>
                        </Form.Control.Feedback>
                      )}
                    </div>
                  </Form.Group>
                </Col>
                <Col xl={7} lg={7} md={7}>
                  <Form.Group className="form-group">
                    <Form.Label className="login-label">
                      Support Email ID{" "}
                      <span className="ms-1 red-color-text">*</span>
                    </Form.Label>
                    <div className="position-relative">
                      <Form.Control
                        type="text"
                        maxLength={167}
                        placeholder="Enter support email ID"
                        className="common-input"
                        value={input.supportemail}
                        onChange={(e) =>
                          setInput({
                            ...input,
                            supportemail: e.target.value,
                          })
                        }
                        isInvalid={input?.errors?.supportemail}
                      />
                      {input.errors.supportemail && (
                        <Form.Control.Feedback type="invalid">
                          <span className="error-message-icon">
                            <img
                              src={infoIcon}
                              alt="infoIcon"
                              title={input.errors.supportemail}
                            />
                          </span>
                        </Form.Control.Feedback>
                      )}
                    </div>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col xl={2} lg={2} md={2}>
                  <Form.Group className="mb-3 form-group">
                    <Form.Label className="common-label">
                      Profile Picture
                    </Form.Label>
                    <div className="position-relative">
                      <div
                        className={`file-input ${
                          input.errors.profilepicfile && "error-border-line"
                        }`}
                      >
                        <input
                          type="file"
                          className="form-control d-none"
                          id="profileImg"
                          ref={ProfileImgref}
                          accept="image/png, image/jpeg"
                          onChange={ProfileChange}
                        />
                        <label
                          className="file-input__label"
                          htmlFor="profileImg"
                        >
                          {file ? (
                            <img height={38} src={file} alt="Profile Image" />
                          ) : (
                            <img
                              height={38}
                              src={PlusPlaceholder}
                              alt="Upload Placeholder"
                            />
                          )}
                        </label>
                      </div>
                    </div>
                  </Form.Group>
                </Col>
                <Col xl={3} lg={3} md={3}>
                  <Form.Group className="form-group">
                    <Form.Label className="common-label">
                      Two Step Verification ?
                    </Form.Label>

                    <div className="position-relative">
                      <Form.Check
                        type="checkbox"
                        id="Enable Two-Step Verification"
                        label="Enable Two-Step Verification"
                        value={input.istwostepenable}
                        checked={input.istwostepenable}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setInput({
                              ...input,
                              istwostepenable: e.target.checked,
                              //
                              errors: {
                                displayname: "",
                                istwostepenable: "",
                                twostepemailid: "",
                                profilepicfile: "",
                                supportemail: "",
                                ValidationRules: [
                                  {
                                    FieldName: "displayname",
                                    ValidationType: "required",
                                    ValidationMessage:
                                      "This Field is a required field",
                                  },

                                  {
                                    FieldName: "supportemail",
                                    ValidationType: "required",
                                    ValidationMessage:
                                      "This Field is a required field",
                                  },
                                  {
                                    FieldName: "supportemail",
                                    ValidationType: "email",
                                    ValidationMessage:
                                      "Enter valid email format required",
                                  },
                                  {
                                    FieldName: "twostepemailid",
                                    ValidationType: "required",
                                    ValidationMessage:
                                      "This Field is a required field",
                                  },
                                  {
                                    FieldName: "twostepemailid",
                                    ValidationType: "email",
                                    ValidationMessage:
                                      "Enter valid email format required",
                                  },
                                ],
                              },
                              //
                            });
                          } else {
                            setInput({
                              ...input,
                              istwostepenable: e.target.checked,
                              twostepemailid: "",
                              errors: {
                                displayname: "",
                                istwostepenable: "",
                                // twostepemailid: "",
                                profilepicfile: "",
                                supportemail: "",
                                ValidationRules: [
                                  {
                                    FieldName: "displayname",
                                    ValidationType: "required",
                                    ValidationMessage:
                                      "This Field is a required field",
                                  },

                                  {
                                    FieldName: "supportemail",
                                    ValidationType: "required",
                                    ValidationMessage:
                                      "This Field is a required field",
                                  },
                                  {
                                    FieldName: "supportemail",
                                    ValidationType: "email",
                                    ValidationMessage:
                                      "Enter valid email format required",
                                  },
                                ],
                              },
                            });
                          }
                        }}
                      />
                    </div>
                  </Form.Group>
                </Col>
                <Col xl={7} lg={7} md={7}>
                  {input.istwostepenable && (
                    <Form.Group className="form-group">
                      <Form.Label className="login-label">
                        Two-Step Email ID{" "}
                        <span className="ms-1 red-color-text">*</span>
                      </Form.Label>
                      <div className="position-relative">
                        <Form.Control
                          type="text"
                          maxLength={167}
                          placeholder="Two-Step Email ID"
                          className="common-input"
                          value={input.twostepemailid}
                          onChange={(e) =>
                            setInput({
                              ...input,
                              twostepemailid: e.target.value,
                            })
                          }
                          isInvalid={input?.errors?.twostepemailid}
                        />
                      </div>
                    </Form.Group>
                  )}
                </Col>
              </Row>
              {/* <Row>
                <Col xl={12} lg={12} md={12}>
                  <Form.Group className="mb-3 form-group">
                    <Form.Label className="common-label">
                      Privacy Policy
                    </Form.Label>
                    <div className="position-relative">
                      <div
                        className={`${
                          input.errors.privacypolicy && "error-border-line"
                        }`}
                      >
                        <CKeditorComponent
                          onChange={handleCKEditor}
                          tag="privacypolicy"
                          value={input.privacypolicy}
                        />
                      </div>
                      {input.errors.privacypolicy && (
                        <p className="error-line">
                          <span className="error-message-icon">
                            <img
                              src={infoIcon}
                              alt="infoIcon"
                              title={input.errors.privacypolicy}
                            />
                          </span>
                        </p>
                      )}
                    </div>
                  </Form.Group>
                </Col>
                <Col xl={12} lg={12} md={12}>
                  <Form.Group className="mb-3 form-group">
                    <Form.Label className="common-label">
                      Terms & Conditions
                    </Form.Label>
                    <div className="position-relative">
                      <div
                        className={`${
                          input.errors.termsandcondition && "error-border-line"
                        }`}
                      >
                        <CKeditorComponent
                          onChange={handleCKEditor}
                          tag="termsandcondition"
                          value={input.termsandcondition}
                        />
                      </div>
                      {input.errors.termsandcondition && (
                        <p className="error-line">
                          <span className="error-message-icon">
                            <img
                              src={infoIcon}
                              alt="infoIcon"
                              title={input.errors.termsandcondition}
                            />
                          </span>
                        </p>
                      )}
                    </div>
                  </Form.Group>
                </Col>
              </Row> */}
            </>

            <div className="footer-btn-section">
              <Button className="mt-2 me-2" disabled={Loading} type="submit">
                {Loading ? (
                  // <>
                  //   <span>Loading</span>
                  //   <Spinner
                  //     className="ms-1"
                  //     animation="border"
                  //     role="status"
                  //     size="sm"
                  //   >
                  //     <span className="visually-hidden">Loading...</span>
                  //   </Spinner>
                  // </>
                  <SubmitLoading />
                ) : (
                  "Submit"
                )}
              </Button>
            </div>
          </div>
        </Form>
      </div>
    </>
  );
};

export default ProfileModule;
